import React from 'react'
import './styles.scss'

const ErrorNotice = ({ errorCode, message, nextRenew, onClose }) => {
  if (!errorCode) return null

  const handleClose = () => {
    // callback logic here
    onClose()
  }

  const isRateLimited = errorCode === 429

  if (isRateLimited) {
    const renewDate = nextRenew ? formatRenewDate(nextRenew) : null

    return (
      <div className='error-notice error-notice--limit'>
        <div className='error-notice__close' onClick={handleClose}>
          <i className="fas fa-times"></i>
        </div>
        <div className='error-notice__icon'>
          <i className="fas fa-hourglass-end"></i>
        </div>
        <div className='error-notice__content'>
          <div className='error-notice__title'>You've reached today's usage limit</div>
          <div className='error-notice__message'>
            {renewDate ? (
              <>Come back on <span className='error-notice__date'>{renewDate}</span> to continue.</>
            ) : (
              <>Please check back later to continue.</>
            )}
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className='error-notice error-notice--server'>
      <div className='error-notice__close' onClick={handleClose}>
        <i className="fas fa-times"></i>
      </div>
      <div className='error-notice__icon'>
        <i className="fas fa-exclamation-triangle"></i>
      </div>
      <div className='error-notice__content'>
        <div className='error-notice__title'>Something went wrong</div>
        <div className='error-notice__message'>
          {message || "We're having trouble connecting. Please try again."}
        </div>
      </div>
    </div>
  )
}

const formatRenewDate = (isoString) => {
  try {
    const date = new Date(isoString)
    const now = new Date()
    const tomorrow = new Date(now)
    tomorrow.setDate(tomorrow.getDate() + 1)

    const isToday = date.toDateString() === now.toDateString()
    const isTomorrow = date.toDateString() === tomorrow.toDateString()

    const timeStr = date.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })

    if (isToday) {
      return `today at ${timeStr}`
    } else if (isTomorrow) {
      return `tomorrow at ${timeStr}`
    } else {
      const dateStr = date.toLocaleDateString([], { weekday: 'short', month: 'short', day: 'numeric' })
      return `${dateStr} at ${timeStr}`
    }
  } catch {
    return null
  }
}

export default ErrorNotice
